<template>
  <v-container>
<!--     <v-layout row wrap>
      <v-flex lg12 xs12 mb-2>
        <v-card dark color="primary">
          <v-card-text class="px-4 text-md-center">
            <span>{{title}}</span>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout> -->



    <v-layout row wrap align-center justify-center v-if="toolObject">
      <v-flex lg10 xs12 mb-2>
  <v-toolbar dense>



    <v-menu  bottom offset-y>
            <v-btn  icon slot="activator" flat aria-label="Folder" >
              <v-icon color="blue" class="mr-1">folder</v-icon>
            </v-btn>
       <v-list >
<!--         <v-list-tile  @click="fileMnu('new')">
          <v-list-tile-title> Новый </v-list-tile-title>
        </v-list-tile>  -->
        <v-list-tile  @click="fileMnu('save')">
          <v-list-tile-title> Сохранить работу</v-list-tile-title>
        </v-list-tile>
        <v-list-tile  @click="fileMnu('open')">
          <v-list-tile-title> Загрузить работу</v-list-tile-title>
        </v-list-tile>
<!--         <v-list-tile  @click="fileMnu('savePDF')" v-if="currentItem.dimMM">
          <v-list-tile-title> Сохранить как PDF </v-list-tile-title>
        </v-list-tile> -->
      </v-list>
<!--      -->
      <v-list>
        <v-list-tile  @click="fileMnu('saveJPEG')">
          <v-list-tile-title> Сохранить как JPEG </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
    <v-divider
      class="mx-2"
      vertical
    ></v-divider>


<v-tooltip bottom>
      <v-btn icon :value="'undo'" slot="activator" :disabled="undoOff" flat  @click="toolsButton('undo')" aria-label="Undo">
        <v-icon>undo</v-icon>
      </v-btn>
      <span>Отмена назад</span>
</v-tooltip>


<v-tooltip bottom>
      <v-btn icon :value="'redo'" slot="activator" :disabled="redoOff" flat  @click="toolsButton('redo')" aria-label="Redo">
        <v-icon>redo</v-icon>
      </v-btn>
      <span>Отмена вперед</span>
</v-tooltip>

    <v-divider
      class="mx-2"
      vertical
    ></v-divider>



    <v-menu  bottom offset-y >

            <v-btn slot="activator" icon flat aria-label="Menu Add">

              <v-icon >fa-plus-square</v-icon>

            </v-btn>



      <v-list >

<!--         <v-list-tile  @click="fileMnuAdd('image')">
          <v-tooltip right>
              <v-list-tile-title slot="activator"> <v-uploader :preview="false" :button-icon="false" :item-limit="1" button-text=" " @done="uploadDone" >  </v-uploader> <v-icon>fa-image</v-icon> </v-list-tile-title>
          <span>Добавить свою картинку</span>
          </v-tooltip>
        </v-list-tile> -->

        <v-list-tile  @click="fileMnuAdd('text')">
          <v-tooltip right>
              <v-list-tile-title slot="activator"> <v-icon>fa-font</v-icon> </v-list-tile-title>
          <span>Добавить Текст</span>
          </v-tooltip>
        </v-list-tile>

        <v-list-tile  @click="fileMnuAdd('rectangle')">
          <v-tooltip right>
              <v-list-tile-title slot="activator"> <v-icon>fa-square</v-icon> </v-list-tile-title>
          <span>Добавить прямоугольник</span>
          </v-tooltip>
        </v-list-tile>

        <v-list-tile  @click="fileMnuAdd('circle')">
          <v-tooltip right>
              <v-list-tile-title slot="activator"> <v-icon>fa-circle</v-icon> </v-list-tile-title>
          <span>Добавить круг</span>
          </v-tooltip>
        </v-list-tile>
      </v-list>
    </v-menu>



    <v-divider
      class="mx-2"
      vertical
    ></v-divider>

<v-tooltip bottom>
      <v-btn icon :value="'copy'" slot="activator" flat :disabled="isSelectObj"  @click="toolsButton('copy')" aria-label="Copy Object">
        <v-icon>fa-clone</v-icon>
      </v-btn>
      <span>Дублировать</span>
</v-tooltip>


    <v-divider
      class="mx-2"
      vertical
    ></v-divider>


<v-tooltip bottom>
      <v-btn icon :value="'swap-h'" slot="activator" flat  @click="toolsButton('color')" aria-label="Set Color Object">
        <v-icon>format_color_fill</v-icon>
      </v-btn>
      <span>Назначить цвет</span>
</v-tooltip>


    <v-divider
      class="mx-2"
      vertical
    ></v-divider>



<v-tooltip bottom>
      <v-btn icon :value="'layer-up'" slot="activator" flat :disabled="isSelectObj" @click="toolsButton('layer-up')" aria-label="Layer Up">
            <v-icon>vertical_align_top</v-icon>
      </v-btn>
      <span>Поднять слой вверх</span>
    </v-tooltip>

<v-tooltip bottom>
      <v-btn icon :value="'layer-dn'" slot="activator"  flat :disabled="isSelectObj" @click="toolsButton('layer-dn')" aria-label="Layer Down">
            <v-icon>vertical_align_bottom</v-icon>
      </v-btn>
      <span>Опустить слой вниз</span>
    </v-tooltip>



    <v-divider
      class="mx-2"
      vertical
    ></v-divider>


<v-tooltip bottom>
      <v-btn icon :value="'swap-h'" slot="activator" flat :disabled="isSelectObj" @click="toolsButton('swap-h')" aria-label="Flip Horizontal">
                 <v-img
                  src="/images/buttons/b-swap-h.svg"
                  aspect-ratio="1"
                  :contain="true"
                  width="30"
                  height="30"

                >
                 </v-img>
      </v-btn>
      <span>Отзеркалить по горизонтали</span>
    </v-tooltip>

<v-tooltip bottom>
      <v-btn icon :value="'swap-v'" slot="activator"  flat :disabled="isSelectObj" @click="toolsButton('swap-v')" aria-label="Flip Vertical">
                 <v-img
                  src="/images/buttons/b-swap-v.svg"
                  aspect-ratio="1"
                  :contain="true"
                  width="30"
                  height="30"
                  :style="{ 'opacity: 0.4': isSelectObj}"

                >
                 </v-img>
      </v-btn>
      <span>Отзеркалить по вертикали</span>
    </v-tooltip>

    <v-divider
      class="mx-2"
      vertical
    ></v-divider>



<v-tooltip bottom>
      <v-btn icon :value="'delete'" slot="activator" flat :disabled="isSelectObj" @click="toolsButton('delete')" aria-label="Delete Object">
        <v-icon color="red darken-4">delete</v-icon>
      </v-btn>
      <span>Удалить</span>
</v-tooltip>


    <v-divider vertical
      v-show="toolText"
      ></v-divider>


    <v-overflow-btn
      :items="dropdown_font"
      v-model="selectFont"
      label="Выберите шрифт"
      hide-details
      class="pa-0"
      v-show="toolText"
    ></v-overflow-btn>



    <v-divider
      class="mr-2"
      vertical
      v-show="toolText"
    ></v-divider>

    <v-btn-toggle
      v-model="toggle_multiple"
      class="transparent"
      multiple
      v-show="toolText"
      aria-label="Text toggle"
    >
      <v-btn :value="1" flat aria-label="Bold">
        <v-icon>format_bold</v-icon>
      </v-btn>

      <v-btn :value="2" flat aria-label="Italic">
        <v-icon>format_italic</v-icon>
      </v-btn>

<!--       <v-btn :value="3" flat>
        <v-icon>format_underlined</v-icon>
      </v-btn> -->

    </v-btn-toggle>

    <v-divider
      class="mx-2"
      vertical
      v-show="toolText"
    ></v-divider>

    <v-btn-toggle
      v-model="toggle_exclusive"
      class="transparent"
      v-show="toolText"
      aria-label="Toggle Align"
    >
      <v-btn :value="1" flat aria-label="Left">
        <v-icon>format_align_left</v-icon>
      </v-btn>

      <v-btn :value="2" flat aria-label="Center">
        <v-icon>format_align_center</v-icon>
      </v-btn>

      <v-btn :value="3" flat aria-label="Right">
        <v-icon>format_align_right</v-icon>
      </v-btn>

      <v-btn :value="4" flat aria-label="Justify">
        <v-icon>format_align_justify</v-icon>
      </v-btn>

    </v-btn-toggle>







  </v-toolbar>
      </v-flex>
    </v-layout>




    <v-layout row wrap>
      <v-flex lg1 xs12>
        <v-card light color="white" >


        </v-card>

      </v-flex>


<!-- <input
  id="file-input"
  type="file"
  name="namef"
  ref="inpfile"
  @change="previewFiles"
  style="display: none;"
  multiple/> -->
<input type="file" ref="inpfile" accept=".cardln"  @change="previewFiles" v-show="false" >

      <v-flex lg10 xs12 mx-0 >
        <v-card dark color="grey lighten-4">
          <v-card-text class="pa-4 container-canvas" >
            <!-- <canvas id="canvas" :width="wCanvas" :height="hCanvas" class="text-md-center"></canvas> -->
            <canvas id="canvas" class="text-md-center"></canvas>
            <div class=" text-md-center" :class="{ 'borderCanvasPrint':printItem, 'borderCanvasWEB':!printItem, }" :style="{ width: wCanvas + 'px' , height: hCanvas + 'px', margin: '-'+ hCanvas +'px auto  auto  auto' }" ></div>
          </v-card-text>
        </v-card>
      </v-flex>





      <v-flex lg2 xs12>

      </v-flex>

    </v-layout>



<v-layout row wrap mt-4 align-center justify-center >

  <v-card light  color="grey lighten-4 flex lg10" >
    <v-layout align-center justify-center row py-2>
          <h6 class="title">Набор графических элементов</h6>
    </v-layout >
    <v-layout row wrap align-center justify-center v-if="toolObject">
      <!-- <v-flex lg3 xs12 mb-2> -->



<!--
<v-tooltip bottom>
      <v-btn  :value="'undo'" slot="activator"   @click="fileMnuLib('template')" :class="{'amber lighten-3': activeLib === 0}" >
        <v-icon>fa-file-image</v-icon> <span class="ml-1 hidden-md-and-down"> Шаблоны</span>
      </v-btn>
      <span>Шаблоны</span>
</v-tooltip> -->

<v-tooltip bottom>
      <v-btn  :value="'element'" slot="activator"   @click="fileMnuLib('objects')" :class="{'amber lighten-3': activeLib === 1}" aria-label="Elements">
        <v-icon>fa-splotch</v-icon><span class="ml-1 hidden-md-and-down"> Элементы</span>
      </v-btn>
      <span>Элементы</span>
</v-tooltip>

<v-tooltip bottom>
      <v-btn  :value="'Background'" slot="activator"   @click="fileMnuLib('bg')" :class="{'amber lighten-3': activeLib === 2}" aria-label="Background">
        <v-icon>fa-image</v-icon><span class="ml-1 hidden-md-and-down"> Фон</span>
      </v-btn>
      <span>Фон</span>
</v-tooltip>
<v-tooltip bottom>
      <v-btn  :value="'Upload'" slot="activator" aria-label="Upload Image">
        <v-uploader :preview="false" :fileTypeExts="'jpeg,jpg,gif,png,svg'" :item-limit="1" button-text="Выберите свою картинку " @done="uploadDone"  >  </v-uploader>
      </v-btn>
      <span>Вставить свою картинку</span>
</v-tooltip>


      <!-- </v-flex> -->
    </v-layout>

    <v-layout align-center justify-center row >
          <h6 class="title">Тема</h6>
    </v-layout >
    <v-layout align-center justify-center row wrap>
      <!-- <v-flex lg6 xs12 > -->

      <v-btn
      small
      round
      @click="filterLib(kf)"
      :class="{'deep-purple lighten-3': activeFiltrImg === kf}"
      v-for="(filtrItem , kf) in currentThemeItem"
      :key="'kf-'+kf"
      v-if="filtrItem.viewLib"
      aria-label="Round"
      >
         {{filtrItem.name}}
      </v-btn>


      <!-- </v-flex> -->
    </v-layout>

                        <v-card
                          color="white"
                          light
                          flat
                          tile
                        >
                          <v-window v-model="onboarding">
                            <v-window-item
                              v-for="n in numPageSlider"
                              :key="`card-${n}`"
                            >
                              <v-card
                                color="transparent"
                                height="144"
                              >
                                <v-layout>
                                  <v-flex xs12 lg12 >
                                    <v-card>
                                      <v-container grid-list-sm fluid>
                                        <v-layout row >
                                          <v-flex
                                            v-for="(item,i) in libBGTest[n-1]"
                                            :key="'fg-'+i"
                                            xs2
                                            d-flex
                                          >
                                            <v-card flat tile class="d-flex">
                                              <v-img
                                                :src="item"
                                                :lazy-src="item"
                                                :width="120"
                                                :height="120"
                                                contain
                                                aspect-ratio="1"
                                                class="grey lighten-2"
                                                @click="selectImg(item)"
                                              >
                                                <v-layout
                                                  slot="placeholder"
                                                  fill-height
                                                  align-center
                                                  justify-center
                                                  ma-0
                                                >
                                                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                                </v-layout>
                                              </v-img>
                                            </v-card>
                                          </v-flex>
                                        </v-layout>
                                      </v-container>
                                    </v-card>
                                  </v-flex>
                                </v-layout>


<!--                                 <v-layout
                                      v-for="(item,i) in libBGTest"
                                      :key="i"
                                      >
                                  <v-flex xs12 lg3 >
                                    <v-card>
                                    <v-img

                                      :src="item"
                                      :width="160"
                                      :height="160"
                                      aspect-ratio="1"
                                      class="grey lighten-4"
                                      @click="selectImg(item)"

                                    >

                                                <v-layout
                                                  slot="placeholder"
                                                  fill-height
                                                  align-center
                                                  justify-center
                                                  ma-0
                                                >
                                                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                                </v-layout>

                                    </v-img>
                                  </v-card>
                                  </v-flex>
                                </v-layout> -->

                              </v-card>
                            </v-window-item>
                          </v-window>

                          <v-card-actions class="justify-space-between">
                            <v-btn
                              color="black"
                              flat
                              @click="prevSlide"
                              aria-label="Prev Slide"
                            >
                              <v-icon>fa-chevron-left</v-icon>
                            </v-btn>
                            <v-item-group
                              v-model="onboarding"
                              class="text-xs-center"
                              mandatory
                            >
                              <v-item
                                v-for="n in numPageSlider"
                                :key="`btn-${n}`"
                              >
                                <v-btn
                                color="grey darken-1"
                                  slot-scope="{ active, toggle }"
                                  :input-value="active"
                                  icon
                                  class="tgglbtn"
                                  @click="toggle"
                                  aria-label="Dot"
                                >
                                  <v-icon size="16">fa-dot-circle</v-icon>
                                </v-btn>
                              </v-item>
                            </v-item-group>
                            <v-btn
                              color="black"
                              flat
                              @click="nextSlide"
                              aria-label="Next Slide"
                            >
                              <v-icon >fa-chevron-right</v-icon>
                            </v-btn>
                          </v-card-actions>
                        </v-card>



</v-card>

<v-card>


</v-card>
</v-layout>


      <v-dialog
            v-model="dialogColor"
            max-width="250"
          >
            <v-card  class="pa-3">


              <!-- <photoshop-picker :value="colors"  @ok="onOk" @cancel="onCancel" /> -->
              <!-- <photoshop-picker v-model="colors" @input="updateValue"  @ok="onOk" @cancel="onCancel" /> -->
              <!-- <chrome-picker v-model="colors" @input="updateValue"  @ok="onOk" @cancel="onCancel" /> -->
              <sketch-picker v-model="colors" @input="updateValue"  @ok="onOk" @cancel="onCancel" :presetColors="arrSpot" />

              <v-card-actions>
                <v-spacer></v-spacer>

              <v-btn small @click="onCancel" aria-label="Cancel">
                Cancel
              </v-btn>
              <v-btn small @click="onOk" aria-label="Ok">
                Ok
              </v-btn>

              </v-card-actions>
            </v-card>
          </v-dialog>

<img id="inputImg" src="" alt="" style="display:none">
</v-container>
</template>

<script>

    // TODO Заменить строку
    // NOTE  Заменить строку
    // ! Внимание
    // ? Вопрос






// ================= Function round to discret number ================== //
function roundTo(value, base) {
    return Math.floor((value + base / 2) / base) * base;
};




import axios from "axios";
import { mapState } from "vuex";
import router from "../router";
import { Photoshop } from 'vue-color'
import { Chrome } from 'vue-color'
import { Sketch } from 'vue-color'

export default {
  name: "CoreEditor",

  components: {
    'photoshop-picker': Photoshop,
    'chrome-picker': Chrome,
    'sketch-picker': Sketch
  },
  props: {
    title: String,
   // type: String,
    widthCanvas: Number,
    heightCanvas: Number
  },
  data: () => ({
    arrStateCanvas:[],
  //  wCanvas: 0,
  //  hCanvas: 0,
    length: 3,
    onboarding: 0,
    numPageSlider: 1,
    numSlidePerPage: 8,
    stepsUndo:25,
    currLib:1,
    headTitle:'Заголовок для HEAD',
    undoOff: true,
    redoOff: true,
    currNumState: 0,
    currentPage:0,
    activeTabs: null,
    toolText: false,
    toolObject: true,
    dialogImageBG: false,
    dialogColor: false,
    orient: true,
    isSelectObj: false,
    activeLib: 0,
    activeFiltrImg: 0,
    arrSpot: ['#000000FF','#FFFFFFFF','#FF0000FF','#00FF00FF','#0000FFFF','#FFFF00FF','#00FFFFFF','#FF00FFFF','#E91E63FF','#9C27B0FF','#CDDC39FF','#FF9800FF','#795548FF','#212121FF','#616161FF','#BDBDBDFF'],
    listThemes: {title: ["Микс","Новый год","Пасха","День св. Валентина", "День рождения","Halloween"], path:["mix","newyear","easter","valentine","bday","halloween"]},
    colorsIn: '#ab6a1e',
    colors: '#33ff00',
    selectColors: '',
    fileName: '',
    files: [],
    selectFont: 'Roboto',
    toggle_exclusive: 1,
    ecosystem: [
      {
        text: "vuetify-loader",
        href: "https://github.com/vuetifyjs/vuetify-loader"
      },
      {
        text: "github",
        href: "https://github.com/vuetifyjs/vuetify"
      },
      {
        text: "awesome-vuetify",
        href: "https://github.com/vuetifyjs/awesome-vuetify"
      }
    ],
      dropdown_font: [
          { text: 'Roboto' },
          { text: 'Arial' },
          { text: 'Lobster' },
          { text: 'Marck Script' }
        ],
        dropdown_edit: [
          { text: '100%' },
          { text: '75%' },
          { text: '50%' },
          { text: '25%' },
          { text: '0%' }
        ],
        toggle_exclusive: 1,
        toggle_multiple: []
  }),
    metaInfo() {
      return {
    title: this.title,
    titleTemplate: '%s - Cardolini',
        meta: [
          { vmid: 'description', name: 'description', content: this.description }
        ]
      }


  },
    watch: {

    '$route' (to, from) {

      console.log(' ============================================== >> watch $route << ===============================================');
      // обрабатываем изменение параметров маршрута...

    let arrInputParam = null;
    let routeParam = this.$route.params.nameItem;
          console.log("Route FROM = ", from);
          console.log("Route TO = ", to);





        switch (to.params.nameItem.split('-')[0]) {
              case 'p':
                   // console.log("arrInputParam PRINT = ", arrInputParam);
                   // console.log("this.koeffOver = ", 1000/(this.dataItemsEdit[0].items[currNumItem].width*this.koeff));


                    arrInputParam = this.dataItemsEdit[0].items.filter(function(iEdit){
                    return iEdit.itemN === to.params.nameItem;
                                    })
                    arrInputParam = arrInputParam[0];


                    if(arrInputParam.width*this.koeff > 1000){
                      //this.localCoeffOver = 1000/this.dataItemsEdit[1].items[namePage].width;
                      //this.$store.commit("currNumItem", namePage);
                      this.$store.commit("koeffOver", 1000/(arrInputParam.width*this.koeff));
                      console.log("koeffOver = ", this.koeffOver);
                      console.log("Ширина больше 1200 px. Делаем ширину = ", arrInputParam.width*this.koeff*this.koeffOver);
                      console.log("Ширина больше 1200 px. Делаем высоту = ", arrInputParam.height*this.koeff*this.koeffOver);
                    }
                    else{
                      this.$store.commit("koeffOver", 1);
                    }

                    console.log("arrInputParam PRINT = ", arrInputParam);
                    this.$store.commit("currentItem", arrInputParam);

                    this.$store.commit("titleHead", this.currentItem.title);
                    this.$store.commit("wCanvas", this.currentItem.width*this.koeff*this.koeffOver);
                    this.$store.commit("hCanvas", this.currentItem.height*this.koeff*this.koeffOver);
                    this.$store.commit("currentThemeItem", this.currentItem.themeItem);

                    console.log("setHeight = ", this.hCanvas);
                    console.log("setWidth = ", this.wCanvas);
                 

                    this.fileMnuLib('bg');

                    canvas.setHeight(this.hCanvas);
                    canvas.setWidth(this.wCanvas);

                    canvas.renderAll();

/*                     let dataC = {canvas: '' }

                    if(localStorage[this.currentItem.itemN]){
                      console.log("load from localStorage data = ", JSON.parse(localStorage.getItem(this.currentItem.itemN)));
                      canvas.loadFromJSON(JSON.parse(localStorage.getItem(this.currentItem.itemN)), canvas.renderAll.bind(canvas));

                    }
                    else{
                        localStorage[this.currentItem.itemN] = JSON.stringify(dataC);
                    }
 */


                break;
              case 'w':
                    arrInputParam = this.dataItemsEdit[1].items.filter(function(iEdit){
                    return iEdit.itemN === to.params.nameItem;
                                    })
                    arrInputParam = arrInputParam[0];
                    console.log("arrInputParam WEB = ", arrInputParam);
                    this.$store.commit("currentItem", arrInputParam);

                    this.$store.commit("titleHead", this.currentItem.title);
                    this.$store.commit("wCanvas", this.currentItem.width*this.koeffOver);
                    this.$store.commit("hCanvas", this.currentItem.height*this.koeffOver);

                    this.$store.commit("currentThemeItem", this.currentItem.themeItem);

                    this.fileMnuLib('bg');


                    canvas.setHeight(this.hCanvas);
                    canvas.setWidth(this.wCanvas);

                    canvas.renderAll();

                break;

              default:
                break;
        }








              switch (to) {
                    case 'p-150x100':
                      canvas.setHeight(this.hCanvas);
                      canvas.setWidth(this.wCanvas);
                      break;
                    case 'p-90x50':

                      break;

                    case 'p-50x90':

                      break;
                    case 'p-210x297-list':

                      break;


                    case 'postcard-print-1side':

                      break;
                    case 'bcard-print-1side':

                      break;
                    case 'vcard-print-1side':

                      break;
                    case 'listovka-a4-1side':

                      break;


                    case 'banner-800x540':

                      break;
                    case 'banner-728x90':

                      break;
                    case 'banner-etsy-760x100':

                      break;
                    case 'banner-etsy-1200x300':

                      break;
                    case 'banner-yam-760x75':

                      break;


                    case 'w-800x540':

                      break;
                    case 'w-728x90':

                      break;
                    case 'w-760x100':

                      break;
                    case 'w-1200x300':

                      break;
                    case 'w-760x75':

                      break;


                    default:
                      break;
}





    },
      currNumState(val, oldVal){
            console.log("Новое значение currNumState: ", val);
            console.log("Старое значение currNumState: ", oldVal);
            if(val){
              this.undoOff = false;
              if(val < this.arrStateCanvas.length){
                this.redoOff = false;
              }
              else{
                this.redoOff = true;
              }

            }
            else{
              this.undoOff = true;
              this.redoOff = false;

            }
      },
      selectFont(val, oldVal){
            console.log("Новое значение FontFamyli: ", val);
            console.log("Старое значение FontFamyli: ", oldVal);

            let selectedGr = [];
            selectedGr = canvas.getActiveObjects();

      for (let sind = 0; sind < selectedGr.length; sind++) {
        const elSelection = selectedGr[sind];
        elSelection.fontFamily = val;
        canvas.renderAll();
        canvas.renderAll.bind(canvas);


      }



	          //this.saveState();
      },
      toggle_multiple(val, oldVal){
            console.log("Новое значение FontStyle: ", val);
            console.log("Старое значение FontStyle: ", oldVal);

            let selectedGr = [];
            selectedGr = canvas.getActiveObjects();

      for (let sind = 0; sind < selectedGr.length; sind++) {
        const elSelection = selectedGr[sind];
                        elSelection.fontWeight = 'normal';
                        elSelection.fontStyle = 'normal';
      console.log("selectObj textbox ",elSelection);
          if(this.toggle_multiple.length){
                  for (let ix = 0; ix < this.toggle_multiple.length; ix++) {
                    const elix = this.toggle_multiple[ix];

                  switch (elix) {
                    case 1:
                      elSelection.fontWeight = 'bold';
                      canvas.renderAll();
                      break;
                    case 2:
                      elSelection.fontStyle = 'italic';
                      canvas.renderAll();
                      break;
                    case 3:
/*                       elSelection.fontStyle = 'oblique';
                      canvas.renderAll(); */
                      break;
                    default:

                      break;


                  }
                  };



          }

          else {
                        console.log("deselect");
                        elSelection.fontWeight = 'normal';
                        elSelection.fontStyle = 'normal';
                        canvas.renderAll();



          }



            }



            canvas.renderAll();


      },
      toggle_exclusive(val, oldVal){
            console.log("Новое значение align: ", val);
            console.log("Старое значение align: ", oldVal);
      let selectedGr = [];
      selectedGr = canvas.getActiveObjects();
for (let sind = 0; sind < selectedGr.length; sind++) {
  const elSelection = selectedGr[sind];


console.log("selectObj textbox ",elSelection);


      switch (val) {
        case 1:
          elSelection.textAlign = 'left';
          canvas.renderAll();
          break;
        case 2:
          elSelection.textAlign = 'center';
          canvas.renderAll();
          break;
        case 3:
          elSelection.textAlign = 'right';
          canvas.renderAll();
          break;
        case 4:
          elSelection.textAlign = 'justify-left';
          canvas.renderAll();
          break;

        default:
          break;

   console.log("selectObj textbox ",elSelection);
      }
      };

      canvas.renderAll();

      },
      dialogImageBG(val, oldVal){
            console.log("Новое значение currentFloor: ", val);
            console.log("Старое значение currentFloor: ", oldVal);



      },


    },
updated: function (et) {
 // console.log("Update = ", et);
  this.$nextTick(function () {
    // Code that will run only after the
    // entire view has been re-rendered


  })
},
  beforeRouteUpdate (to, from, next) {

    console.log("Route FROM = ", from);
    console.log("Route TO = ", to);
    console.log("Route NEXT = ", next);
    // обрабатываем изменение параметров маршрута...
    // не забываем вызвать next()
  },

  beforeMount() {
console.log(' ============================================== >> beforeMount CoreEditor << ===============================================');

    let arrInputParam = null;
    let routeParam = this.$route.params.nameItem;
    console.log("nameItem = ", routeParam);
    console.log("this.koeff = ", this.koeff);
    console.log("widthCanvas = ", this.widthCanvas);
    console.log("heightCanvas = ", this.heightCanvas);

    this.$store.commit("wCanvas", this.widthCanvas);
    this.$store.commit("hCanvas", this.heightCanvas);



console.log("nameItem = ", routeParam.split('-')[0]);

        switch (routeParam.split('-')[0]) {
              case 'p':
                   // console.log("arrInputParam PRINT = ", arrInputParam);
                   // console.log("this.koeffOver = ", 1000/(this.dataItemsEdit[0].items[currNumItem].width*this.koeff));


                    arrInputParam = this.dataItemsEdit[0].items.filter(function(iEdit){
                    return iEdit.itemN === routeParam;
                                    })
                    arrInputParam = arrInputParam[0];


                    if(arrInputParam.width*this.koeff > 1000){
                      //this.localCoeffOver = 1000/this.dataItemsEdit[1].items[namePage].width;
                      //this.$store.commit("currNumItem", namePage);
                      this.$store.commit("koeffOver", 1000/(arrInputParam.width*this.koeff));
                      console.log("koeffOver = ", this.koeffOver);
                      console.log("Ширина больше 1200 px. Делаем ширину = ", arrInputParam.width*this.koeff*this.koeffOver);
                      console.log("Ширина больше 1200 px. Делаем высоту = ", arrInputParam.height*this.koeff*this.koeffOver);
                    }

                    console.log("arrInputParam PRINT = ", arrInputParam);
                    this.$store.commit("currentItem", arrInputParam);

                    this.$store.commit("titleHead", this.currentItem.title);
                    this.$store.commit("wCanvas", this.currentItem.width*this.koeff*this.koeffOver);
                    this.$store.commit("hCanvas", this.currentItem.height*this.koeff*this.koeffOver);

/*                     let dataC = {canvas: '' }

                    if(localStorage[this.currentItem.itemN]){
                      console.log("load from localStorage data = ", JSON.parse(localStorage.getItem(this.currentItem.itemN)));
                      canvas.loadFromJSON(JSON.parse(localStorage.getItem(this.currentItem.itemN)), canvas.renderAll.bind(canvas));

                    }
                    else{
                        localStorage[this.currentItem.itemN] = JSON.stringify(dataC);
                    }
 */


                break;
              case 'w':
                    arrInputParam = this.dataItemsEdit[1].items.filter(function(iEdit){
                    return iEdit.itemN === routeParam;
                                    })
                    arrInputParam = arrInputParam[0];
                    console.log("arrInputParam WEB = ", arrInputParam);
                    this.$store.commit("currentItem", arrInputParam);

                    this.$store.commit("titleHead", this.currentItem.title);
                    this.$store.commit("wCanvas", this.currentItem.width*this.koeffOver);
                    this.$store.commit("hCanvas", this.currentItem.height*this.koeffOver);

                break;

              default:
                break;
        }







  },
  mounted() {
    console.log(' ============================================== >> mounted CoreEditor << ===============================================')
    
    console.log("props title", this.$props.title);
    console.log("props width", this.$props.width);


   // this.$store.commit("titleHead", "Баннер "+this.heightCanvas+"x"+this.widthCanvas);
    /* console.log("name Item =", this.$route.params.nameItem); */
    this.$nextTick(
      function() {
        console.log("PROPS = ", this.$props);




                  this.$store.commit("currentThemeItem", this.itemsObjectImages);
                  this.fileMnuLib('bg');

          canvas = new fabric.Canvas("canvas");
          ctx[this.currentPage] = canvas.getSelectionContext();

          this.setupCanvas();
                    canvas.setHeight(this.hCanvas);
                    canvas.setWidth(this.wCanvas);

                    canvas.renderAll();

/*           setTimeout(
            function() {

              swiper = new Swiper('.swiper-container', {
                  slidesPerView: 10,
                  spaceBetween: 20,
                  slidesPerGroup: 8,
                  loop: false,
                  pagination: {
                    el: '.swiper-pagination',
                    clickable: false,
                  },
                  navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                  },
                  on: {
                    init: function () {
                      console.log("Init swiper");
                    },
                    slideChange: function () {
                      console.log("slideChange");
                    },
                  },
                  // Responsive breakpoints
                  breakpoints: {
                    // when window width is <= 320px
                    320: {
                      slidesPerView: 1,
                      spaceBetween: 5,
                      slidesPerGroup: 1,
                    },
                    // when window width is <= 480px
                    480: {
                      slidesPerView: 2,
                      spaceBetween: 10,
                      slidesPerGroup: 2,
                    },
                    // when window width is <= 640px
                    768: {
                      slidesPerView: 3,
                      spaceBetween: 20,
                      slidesPerGroup: 3,
                    },
                    // when window width is <= 640px
                    960: {
                      slidesPerView: 10,
                      spaceBetween: 20,
                      slidesPerGroup: 8,
                    }
                  },

              });

              console.log("swiper  = ",swiper);

            }.bind(this),
            300
          );
 */

      })
  },

  computed: {
          koeffOver() {
            return this.$store.state.koeffOver;
          },
          koeff() {
            return this.$store.state.koeff;
          },
          currNumItem() {
            return this.$store.state.currNumItem;
          },
          currentItem() {
            return this.$store.state.currentItem;
          },
          currentThemeItem() {
            return this.$store.state.currentThemeItem;
          },
          dataItemsEdit() {
              return this.$store.state.dataItemsEdit ;
          },
          itemsObjectImages() {
            return this.$store.state.itemsObjectImages;
          },
          printItem() {
              return this.$store.state.printItem ;
          },
          hCanvas() {
            return this.$store.state.hCanvas;
          },
          wCanvas() {
            return this.$store.state.wCanvas;
          },
          titleHead() {
            return this.$store.state.titleHead;
          },
          libBGTest() {
            return this.$store.state.libBGTest;
          },
          bgc () {
            return this.colors.hex
          },

  },

  methods: {
    nofunction: function() {
      console.log("run nofunction");
    },


    goToPageW: function(namePage) {
          console.log(' ============================================== >> goToPageW << ===============================================')
          let arrInputParam = null;
          let routeParam = this.$route.params.nameItem;


          console.log("gotoPage = ", namePage);
          console.log("props = ", this.$props);
          console.log("width = ", this.dataItemsEdit[1].items[namePage].width);
          console.log("height = ", this.dataItemsEdit[1].items[namePage].height);
          console.log("currentItem = ", this.dataItemsEdit[1].items[namePage]);


          this.$store.commit("currNumItem", namePage);
          this.$store.commit("currentItem", this.dataItemsEdit[1].items[namePage]);
          this.$store.commit("titleHead", this.dataItemsEdit[1].items[namePage].title);

          console.log("currentItem = ", this.currentItem);

          if(this.dataItemsEdit[1].items[namePage].width > 1000){
            //this.localCoeffOver = 1000/this.dataItemsEdit[1].items[namePage].width;
            this.$store.commit("koeffOver", 1000/this.dataItemsEdit[1].items[namePage].width);
            this.$store.commit("koeffOver", 1);
            console.log("koeffOver = ", this.koeffOver);
            console.log("Ширина больше 1200 px. Делаем ширину = ", this.dataItemsEdit[1].items[namePage].width*this.koeffOver);
            console.log("Ширина больше 1200 px. Делаем высоту = ", this.dataItemsEdit[1].items[namePage].height*this.koeffOver);
          }



          this.$store.commit("wCanvas", this.dataItemsEdit[1].items[namePage].width*this.koeffOver);
          this.$store.commit("hCanvas", this.dataItemsEdit[1].items[namePage].height*this.koeffOver);

          router.push('/editor/'+this.currentItem.itemN);
           this.$store.commit("currentThemeItem", this.currentItem.themeItem);
                 // this.$store.commit("currentThemeItem", this.itemsObjectImages);
                  this.fileMnuLib('bg');
          	    canvas.setHeight(this.hCanvas);
                canvas.setWidth(this.wCanvas);
                canvas.renderAll();

/*           arrInputParam = this.dataItemsEdit[1].items.filter(function(iEdit){
                    return iEdit.itemN === routeParam;
                                    })
                    arrInputParam = arrInputParam[0];
                    console.log("arrInputParam WEB = ", arrInputParam);
                    this.$store.commit("currentItem", arrInputParam);   */
        },
    goToPageP: function(namePage) {

      console.log(' ============================================== >> goToPageP << ===============================================')

          let arrInputParam = null;
          let routeParam = this.$route.params.nameItem;


          console.log("gotoPage = ", namePage);
          console.log("props = ", this.$props);
          console.log("width = ", this.dataItemsEdit[0].items[namePage].width);
          console.log("height = ", this.dataItemsEdit[0].items[namePage].height);
          console.log("currentItem = ", this.dataItemsEdit[0].items[namePage]);


          this.$store.commit("currNumItem", namePage);
          this.$store.commit("currentItem", this.dataItemsEdit[0].items[namePage]);
          this.$store.commit("titleHead", this.dataItemsEdit[0].items[namePage].title);



          if(this.dataItemsEdit[0].items[namePage].width > 1000){
            //this.localCoeffOver = 1000/this.dataItemsEdit[1].items[namePage].width;
            this.$store.commit("koeffOver", 1000/this.dataItemsEdit[0].items[namePage].width);
            this.$store.commit("koeffOver", 1);
            console.log("koeffOver = ", this.koeffOver);
            console.log("Ширина больше 1200 px. Делаем ширину = ", this.dataItemsEdit[0].items[namePage].width*this.koeffOver);
            console.log("Ширина больше 1200 px. Делаем высоту = ", this.dataItemsEdit[0].items[namePage].height*this.koeffOver);
          }

          this.$store.commit("wCanvas", this.dataItemsEdit[0].items[namePage].width*this.koeffOver);
          this.$store.commit("hCanvas", this.dataItemsEdit[0].items[namePage].height*this.koeffOver);


          this.$store.commit("currentThemeItem", this.currentItem.themeItem);
          router.push('/editor/'+this.currentItem.itemN);
          

        },




      nextSlide () {
        this.onboarding = this.onboarding + 1 === this.numPageSlider
          ? 0
          : this.onboarding + 1
      },
      prevSlide () {
        this.onboarding = this.onboarding - 1 < 0
          ? this.numPageSlider - 1
          : this.onboarding - 1
      },
        uploadDone(files){
            if(files && Array.isArray(files) && files.length){
                console.log("put File = ",files[0].url);
                this.putImage(files[0].url);
               // this.fileMnuAdd('image');

            }
        },


    clickOverCanvas: function() {
      console.log("run clickOverCanvas");
      canvas.discardActiveObject(function(e){
        console.log("All Deslect!");
      })
    },

    addIMGBASE64: function() {
      console.log("run addIMGBASE64");
	    let imgObj = new Image();
	    imgObj.src = imgName;
	    let image = new fabric.Image(imgObj);
	    image.set({
	        left: 10,
	        top: 10
	    });
	    //image.scale(getRandomNum(0.1, 0.25)).setCoords();
	    //console.log("Add Crop IMAGE = ",image);
	    deleteObj();
	    canvas.add(image).setActiveObject(image);
	    canvas.renderAll();
	    this.saveState();

    },
    saveAsJPEG: function() {
      console.log("run saveAsJPEG");

	    var dataURL = canvas.toDataURL({
	        format: 'jpeg',
	        quality: 0.85,
	        multiplier: 1/this.koeffOver
	        //multiplier: 1.39
	    });

          console.log(" dataURL = ", dataURL);

        let link = document.createElement('a');
        link.href = dataURL;
        link.download = 'cardoliniimage.jpg';
        document.body.appendChild(link);
        link.click();

    },
    saveFile: function() {
console.log("run saveFile");

      canvas.namecard = this.currentItem.itemN;
	    canvas.version = '2.4.5';


      console.log("dataCanvas : ", canvas.toJSON(['namecard', 'version']));

        //let dataCanvas = JSON.stringify(canvas.toJSON(['namecard', 'version'])).replace('http://cardolini.ru/', '');
        let dataCanvas = JSON.stringify(canvas.toJSON(['namecard', 'version']));
        let zipF = LZString.compressToEncodedURIComponent(dataCanvas);
        console.log("dataCanvas  ZIP : ", zipF);


        let link = document.createElement("a"); // Or maybe get it from the current document
        let blob = new Blob([zipF], {
                "type": "plain/text"
            });
        var url = URL.createObjectURL(blob);
        link.href = url;
        link.download = "mywork.cardln";
        document.body.appendChild(link);

      //window.open(link, '_blank');
        link.click();


    },
    openFile: function() {
      console.log(' ============================================== >> openFile << ===============================================')
      console.log("refs", this.$refs);
      this.$refs.inpfile.click();

    },
    previewFiles: function(ev) {
      console.log(' ============================================== >> previewFiles << ===============================================')
      console.log("ev = ", ev);
      this.files = ev.target.files || ev.dataTransfer.files;
      if (!this.files.length){
        return;
      }


      console.log("Select File = ", this.files[0])



    let reader = new FileReader();
    let currV = this;
    reader.onload =
    (function(fLoad) {
      return function(e) {
        fLoad.src = e.target.result;

      let unzipF = LZString.decompressFromEncodedURIComponent(fLoad.src);
        console.log("fLoad.src atob = ", unzipF)


                  let obj = JSON.parse(unzipF);
                  console.log("obj = ", obj)

                  switch (obj.namecard) {
                    case 'p-150x100':
                      currV.goToPageP(4)
                      break;
                    case 'p-90x50':
                      currV.goToPageP(0)
                      break;

                    case 'p-50x90':
                      currV.goToPageP(2)
                      break;
                    case 'p-210x297-list':
                      currV.goToPageP(6)
                      break;


                    case 'postcard-print-1side':
                      currV.goToPageP(4)
                      break;
                    case 'bcard-print-1side':
                      currV.goToPageP(0)
                      break;
                    case 'vcard-print-1side':
                      currV.goToPageP(2)
                      break;
                    case 'listovka-a4-1side':
                      currV.goToPageP(6)
                      break;


                    case 'banner-800x540':
                      currV.goToPageW(0)
                      break;
                    case 'banner-728x90':
                      currV.goToPageW(1)
                      break;
                    case 'banner-etsy-760x100':
                      currV.goToPageW(4)
                      break;
                    case 'banner-etsy-1200x300':
                      currV.goToPageW(5)
                      break;
                    case 'banner-yam-760x75':
                      currV.goToPageW(6)
                      break;


                    case 'w-800x540':
                      currV.goToPageW(0)
                      break;
                    case 'w-728x90':
                      currV.goToPageW(1)
                      break;
                    case 'w-760x100':
                      currV.goToPageW(4)
                      break;
                    case 'w-1200x300':
                      currV.goToPageW(5)
                      break;
                    case 'w-760x75':
                      currV.goToPageW(6)
                      break;


                    default:
                      break;
                  }

	                canvas.loadFromJSON(obj, canvas.renderAll.bind(canvas));

        };
        })(function(rrt){
          console.log("rrt = ",rrt);
        });
    reader.readAsText(this.files[0]);
  //  reader.readAsDataURL(this.files[0]);
      console.log("reader = ", reader)
    //  console.log("reader.readyState = ", reader.readyState)
    //  console.log("reader.onload = ", reader.onload)
    //  console.log("reader.result = ", reader.result)

    },



    saveAsPDF: function() {
      console.log(' ============================================== >> saveAsPDF << ===============================================')

      const cropD = 3.75
      let doc = new jsPDF();

     // doc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal');
     // doc.setFont('Roboto');

      doc.addFileToVFS('Roboto-Regular.ttf',robotoF);

      doc.addFont('Roboto-Regular.ttf', 'custom', 'normal');

      doc.setFont('custom');




      doc.setFontType("normal");
      doc.setFontSize(12);
      console.log("doc Font =", doc.getFontList());

/**
 * ! Создать обрезные маркеры
*/

      doc.setFillColor(1,1,1,1);


      doc.line(8,15.5,8+cropD,15.5);
      doc.line(13,10.5,13,10.5+cropD);


      doc.line(103,10.5,103,10.5+cropD);
      doc.line(107,10.5,107,10.5+cropD);


      doc.line(198.25,15.5,198.25+cropD,15.5);
      doc.line(197,10.5,197,10.5+cropD);



      doc.line(6,65.5,6+cropD,65.5);
      doc.line(6,69.5,6+cropD,69.5);

      doc.line(200,65.5,200+cropD,65.5);
      doc.line(200,69.5,200+cropD,69.5);

      doc.line(6,119.5,6+cropD,119.5);
      doc.line(6,123.5,6+cropD,123.5);

      doc.line(200,119.5,200+cropD,119.5);
      doc.line(200,123.5,200+cropD,123.5);

      doc.line(6,173.5,6+cropD,173.5);
      doc.line(6,177.5,6+cropD,177.5);

      doc.line(200,173.5,200+cropD,173.5);
      doc.line(200,177.5,200+cropD,177.5);

      doc.line(6,227.5,6+cropD,227.5);
      doc.line(6,231.5,6+cropD,231.5);

      doc.line(200,227.5,200+cropD,227.5);
      doc.line(200,231.5,200+cropD,231.5);


      doc.line(8,281.5,8+cropD,281.5);
      doc.line(13,282.5,13,282.5+cropD);


      doc.line(103,282.5,103,282.5+cropD);
      doc.line(107,282.5,107,282.5+cropD);


      doc.line(198.25,281.5,198.25+cropD,281.5);
      doc.line(197,282.5,197,282.5+cropD);




      doc.text(this.titleHead, 5, 5);
      window.open(doc.output('bloburl'), '_blank');
      //doc.save('a4.pdf');

    },
    filterLib: function(numFiltr) {
      console.log("run filterLib");
      console.log("path name =", this.currentItem.themeItem[numFiltr]);
      let pathFiltr = '';

switch (this.currLib) {
  case 1:
    pathFiltr = this.currentItem.rootPath+this.currentItem.themeItem[numFiltr].themePath+'/thmb/';
    break;
  case 2:
    //pathFiltr = this.currentItem.rootPath+this.currentThemeItem.themePath;
    pathFiltr = this.itemsObjectImages[numFiltr].rootPath+this.itemsObjectImages[numFiltr].themePath+'/';
    break;
  case 3:
    pathFiltr = this.currentItem.rootPath+this.currentItem.themeItem[numFiltr].themePath+'/thmb/';
    break;

  default:
    break;
}
      if(this.currLib)
      this.activeFiltrImg = numFiltr;


              axios({
              method: "post",
              url: "//www.cardolini.ru/includes/gnf.php",
              data:{
               // fpath:  this.currentItem.rootPath+this.currentItem.themeItem[numFiltr].themePath+'/thmb/'
                fpath:  pathFiltr

                }

            })
              .catch(function(error) {
                // handle error
                console.log("ERROR: ", error);
              })
              .then(
                function(response) {
                  // handle success
                  //console.log("response name Pictures =",response.data );
                  this.numPageSlider = Math.ceil(response.data.length/this.numSlidePerPage );
                  this.onboarding = 0;
                  //this.numPageSlider = 3;
                  let tempA =[];

                  for (let xin = 0; xin <= this.numPageSlider; xin++) {
                    console.log("slice =", response.data.slice(this.numSlidePerPage *xin,this.numSlidePerPage*xin+this.numSlidePerPage ));
                      tempA.push( response.data.slice(this.numSlidePerPage *xin,this.numSlidePerPage*xin+this.numSlidePerPage ));

                  }

                  let onlyNameF = response.data.map( function(imN){
                   // console.log("onlyNameF =",imN.split('/'));
                    return imN.split('/')[imN.split('/').length-1];
                  })

                  console.log("temparray =",tempA);
                  console.log("onlyNameF =",onlyNameF);

                  this.$store.commit("libBGTest", tempA);
                 //this.$store.commit("libBGTest", onlyNameF);


                  if (response.data === "0 results") {
                  } else {
                    console.log("All Data POSTS load from server");
                  }
                }.bind(this)
              );

    },
    onOk () {
      console.log('ok')
      this.dialogColor = false;
      this.setColor();
    },
    onCancel () {
      console.log('cancel')
      this.dialogColor = false;
    },
    updateValue (value) {
     // console.log('update = ',value)
      this.colors = value;
    },

    /*************************************************
     * @function setBGImageNEW
     * @param urlImg
     **************************************************/

    setBGImageNEW: function(urlImg) {
      console.log("run setBGImage");
      console.log("ImgUrl = ", urlImg);
      let scaleCoeff = null;
      let vmL = this;
         fabric.Image.fromURL(urlImg, function(img) {
              scaleCoeff = img.width / canvas.width;
              console.log("img = ", img);
              console.log("img.width = ", img.width);
              console.log("scaleCoeff = ", scaleCoeff);

            canvas.setBackgroundImage(urlImg, function(){
                console.log("callback save img = ",canvas);
                console.log("callback save img = ",vmL);
                canvas.renderAll();
               canvas.renderAll.bind(canvas);
               vmL.saveState();
            }.bind(this), {
              width: img.width,
              height: img.height,
              opacity: 1.0,
              angle: 0,
              left: 0,
              top: 0,
              scaleX: 1/scaleCoeff,
              scaleY: 1/scaleCoeff,
              originX: 'left',
              originY: 'top',
              crossOrigin: 'anonymous'
            });
          canvas.renderAll();
         });

    },


    /*************************************************
     * @function setBGImage
     * @param urlImg
     **************************************************/

    setBGImage: function(urlImg) {
      console.log("run setBGImage");
      console.log("ImgUrl = ", urlImg);




	    let imgbg = new Image();
/*       let img = document.getElementById("inputImg");

        imgbg.onload = function() {
            img.src = this.src;
            console.log("img = ", img);
        } */

        imgbg.src = urlImg;


     // imgbg.src = '../assets/cardolini_tmpl/images/postcard/bg/8marta/bg-8march-02.jpg';
     // imgbg.src = '../library/template/bg/all-bg-20.jpg';
      console.log("imgbg = ", imgbg);

      if (this.orient) { // Horizontal
      console.log('width = ', imgbg.width);
      console.log('height = ', imgbg.height);

              let img=new Image();

              let scaleCoeff = imgbg.width / canvas.width;

              console.log('scaleCoeff = ', scaleCoeff);

              let MAXWidthWidth=canvas.width;
              let r=MAXWidthWidth/Math.max(imgbg.width,imgbg.height),
              w=Math.round(imgbg.width*r),
              h=Math.round(imgbg.height*r),
              c=document.createElement("canvas");
              c.width=w;c.height=h/scaleCoeff;
              c.getContext("2d").drawImage(imgbg,0,0,w,h);
              imgbg.src=c.toDataURL();



        let bgImg = canvas.setBackgroundImage(imgbg.src, function(e) {

	            //console.log('CCC hor = ', imgbg.height );
              console.log('canvas.width = ', canvas.width);
              console.log('canvas.height = ', canvas.height);
	           // let scaleCoeff = canvas.backgroundImage.width / canvas.width;
	            canvas.backgroundImage.width = canvas.width;
	            canvas.backgroundImage.height = canvas.backgroundImage.height / scaleCoeff;


	            console.log('widthBG bg image = ', canvas.backgroundImage.width );
	            console.log('heightBG bg image = ', canvas.backgroundImage.height );
	            console.log('Coeff = ', scaleCoeff);
	            canvas.renderAll();
	            canvas.renderAll.bind(canvas);
	            this.saveState();

	        }.bind(this), {
	            //width: widthCanvas,
	            //height: heightCanvas,
	            originX: 'left',
	            originY: 'top',
	            left: 0,
	            top: -1
	        });
 /*
 */

	    } else { // Vertical
	        let bgImg = canvas.setBackgroundImage(imgbg.src, function(e) {

	            console.log('CCC ver = ', imgbg.width);


	            let scaleCoeff = canvas.backgroundImage.height / canvas.height;
	            canvas.backgroundImage.width = canvas.backgroundImage.width / scaleCoeff;
	            canvas.backgroundImage.height = canvas.height;

	            console.log('widthBG bg image = ', canvas.backgroundImage.width);
	            console.log('heightBG bg image = ', canvas.backgroundImage.height);
	            console.log('Coeff = ', scaleCoeff);
	            canvas.renderAll();

	            canvas.renderAll.bind(canvas);
	            this.saveState();



	        }.bind(this), {
	            //width: widthCanvas,
	            //height: heightCanvas,
	            originX: 'left',
	            originY: 'top',
	            left: 0,
	            top: -1
	        });

	    }


    },

    /*************************************************
     * @function putImage
     * @param urlImg
     **************************************************/

    putImage: function(urlImg) {
      console.log("run putImage");
      console.log("ImgUrl = ", urlImg.split('/')[urlImg.split('/').length-1].split('.')[1]);

if(urlImg.split('/')[urlImg.split('/').length-1].split('.')[1] === 'svg'){
	    fabric.loadSVGFromURL(urlImg, function(objects, options) {
	        console.log('objects height = ', canvas.height / options.height, 'objects width = ', canvas.width / options.width);
	        let loadedObject = fabric.util.groupSVGElements(objects, options);
	        loadedObject.set({
	                left: 5,
	                top: 5
	            })
	            .setCoords();
	        canvas.add(loadedObject.scale(Math.min(canvas.height / options.height, canvas.width / options.width))).setActiveObject(loadedObject);

	        canvas.renderAll();
	        this.saveState();
}.bind(this))


}

if(urlImg.split('/')[urlImg.split('/').length-1].split('.')[1] === 'png' || urlImg.split('/')[urlImg.split('/').length-1].split('.')[1] === 'jpg'){
	    let imgPNGName = new Image()
	    imgPNGName.src = urlImg;
	    fabric.Image.fromURL(urlImg, function(img) {
	        //console.log('IMG height = ', heightCanvas/img.height, 'IMG width = ', widthCanvas/img.width);
	        canvas.add(img.set({ left: 5, top: 5, perPixelTargetFind: true }).scale(Math.min(canvas.height / img.height, canvas.width / img.width))).setActiveObject(img);

	        canvas.renderAll();

	    }.bind(this));
	        this.saveState();
}





    },


    /*************************************************
     * @function selectImg
     * @param urlImg
     **************************************************/

    selectImg: function(urlImg) {
      console.log("run selectImg");
      console.log("ImgUrl = ", urlImg);

    if(this.currLib !== 2) {
      this.setBGImageNEW(urlImg.replace("/thmb", ""));
      //this.setBGImage(urlImg.replace("/thmb", ""));
    }
    else {
    this.putImage(urlImg.replace("/thmb", ""));

    }

    },

    /*************************************************
     * @function fileMnuLib
     * @param nmMnuItem
     **************************************************/

    fileMnuLib: function(nmMnuItem) {
      console.log("run fileMnuLib : ", nmMnuItem);


      switch (nmMnuItem) {
        case 'template':
          this.activeLib = 0;
          this.currLib = 1;
          this.activeFiltrImg = 0;

          break;
        case 'objects':
              this.activeLib = 1;
              this.currLib = 2;
              this.activeFiltrImg = 0;

              axios({
              method: "post",
              url: "//www.cardolini.ru/includes/gnf.php",
              data:{
                fpath: this.itemsObjectImages[0].rootPath+this.itemsObjectImages[0].themePath+'/'
                }

            })
              .catch(function(error) {
                // handle error
                console.log("ERROR: ", error);
              })
              .then(
                function(response) {
                  // handle success
                  this.numPageSlider = Math.ceil(response.data.length/this.numSlidePerPage );

                  let tempA =[];

                  for (let xin = 0; xin <= this.numPageSlider; xin++) {
                    console.log("slice =", response.data.slice(this.numSlidePerPage *xin,this.numSlidePerPage*xin+this.numSlidePerPage ));
                      tempA.push( response.data.slice(this.numSlidePerPage *xin,this.numSlidePerPage*xin+this.numSlidePerPage ));

                  }

                  let onlyNameF = response.data.map( function(imN){
                    console.log("onlyNameF =",imN.split('/'));
                    return imN.split('/')[imN.split('/').length-1];
                  })

                  console.log("response name Pictures =",response.data );
                  this.numPageSlider = Math.ceil(response.data.length/8 );


                  console.log("temparray =",tempA);
                  console.log("onlyNameF =",onlyNameF);

                  this.$store.commit("libBGTest", tempA);
                //  this.$store.commit("libBGTest", onlyNameF);
                  this.$store.commit("currentThemeItem", this.itemsObjectImages);


                  if (response.data === "0 results") {
                  } else {
                    console.log("All Data POSTS load from server");
                  }
                }.bind(this)
              );
          break;
        case 'bg':

              this.activeLib = 2;
              this.currLib = 3;
              this.activeFiltrImg = 0;

              let loadPath = this.currentItem.rootPath+this.currentItem.themeItem[0].themePath+'/thmb/';
              console.log("loadPath: ", loadPath);


              axios({
              method: "post",
              url: "//www.cardolini.ru/includes/gnf.php",
              data:{
                fpath: this.currentItem.rootPath+this.currentItem.themeItem[0].themePath+'/thmb/'

                }

            })
              .catch(function(error) {
                // handle error
                console.log("ERROR: ", error);
              })
              .then(
                function(response) {
                  // handle success

                  this.numPageSlider = Math.ceil(response.data.length/this.numSlidePerPage );

                  let tempA =[];

                  for (let xin = 0; xin <= this.numPageSlider; xin++) {
                   // console.log("slice =", response.data.slice(this.numSlidePerPage *xin,this.numSlidePerPage*xin+this.numSlidePerPage ));
                      tempA.push( response.data.slice(this.numSlidePerPage *xin,this.numSlidePerPage*xin+this.numSlidePerPage ));

                  }




                  let onlyNameF = response.data.map( function(imN){
                   // console.log("onlyNameF =",imN.split('/'));
                    return imN.split('/')[imN.split('/').length-1];
                  })

                  console.log("response name Pictures =",response.data );
                  console.log("length =",response.data.length );
                  console.log("pages =",response.data.length/8 );
                  console.log("pages =",Math.ceil(response.data.length/8 ));
                  this.numPageSlider = Math.ceil(response.data.length/8 );

                  console.log("temparray =",tempA);
                  console.log("onlyNameF =",onlyNameF);

                  this.$store.commit("libBGTest", tempA);
                  //this.$store.commit("libBGTest", onlyNameF);

                  this.$store.commit("currentThemeItem", this.currentItem.themeItem);



                  if (response.data === "0 results") {
                  } else {
                    console.log("All Data POSTS load from server");
                  }
                }.bind(this)
              );
          break;

        default:
          break;
      }

    },

    /*************************************************
     * @function fileMnu
     * @param nmMnuItem
     **************************************************/

    fileMnu: function(nmMnuItem) {
      console.log("run fileMnu : ", nmMnuItem);


      switch (nmMnuItem) {
        case 'save':
            this.saveFile();
          break;
        case 'open':
            this.openFile();
          break;
        case 'savePDF':
            this.saveAsPDF();
          break;
        case 'saveJPEG':
            this.saveAsJPEG();
          break;

        default:
          break;
      }

    },
    /*************************************************
     * @function fileMnuAdd
     * @param nmMnuItem
     **************************************************/

    fileMnuAdd: function(nmMnuItem) {
      console.log("run fileMnuAdd : ", nmMnuItem);


      switch (nmMnuItem) {
        case 'text':
            this.addText();
          break;
        case 'rectangle':
          let rectDim = { top: 50, left: 50, width: 100, height: 100 };
          this.addRect(rectDim);
          break;
        case 'circle':
          let circleDim = { top: 100, left: 100, r1: 50, r2: 50 };
          this.addCircle(circleDim);
          break;

        default:
          break;
      }

    },


    /*************************************************
     * @function toolsButton
     * @param nmButton
     **************************************************/

    toolsButton: function(nmButton) {
      console.log("run toolsButton : ", nmButton);

        switch (nmButton) {

          case 'color':
         // this.colors = { r: 0, g: 20, b: 0, a: 1 };
            this.dialogColor = true
            break;
          case 'copy':
            this.copyObject()
            break;
          case 'v-center':
            this.alignCenterV()
            break;
          case 'h-center':
            this.alignCenterH()
            break;
          case 'h-left':
            this.alignLeft()
            break;
          case 'h-right':
            this.alignRight()
            break;
          case 'v-top':
            this.alignTop()
            break;
          case 'v-bottom':
            this.alignBottom()
            break;
          case 'layer-up':
            this.upObj()
            break;
          case 'layer-dn':
            this.dnObj()
            break;
          case 'swap-v':
            this.flipVertical()
            break;
          case 'swap-h':
            this.flipHorizontal()
            break;
          case 'delete':
            this.deleteObj()
            break;
          case 'undo':
            this.undo()
            break;
          case 'redo':
            this.redo()
            break;

          default:
            break;
        }




    },


    /*************************************************
     * @function deleteObj
     * @param none
     **************************************************/

    deleteObj: function() {
      console.log("run deleteObj");
    const arrSelectObj = canvas.getActiveObjects();
    console.log("getActiveObjects = ", arrSelectObj );
	    if (arrSelectObj) {
          canvas.remove(...arrSelectObj);


	    }

	    canvas.renderTop();
	    canvas.renderAll();
	    this.saveState();
    },


    /*************************************************
     * @function updateScope
     * @param none
     **************************************************/

    updateScope: function() {
      console.log("run updateScope");
      canvas.renderAll();
    },

    /*************************************************
     * @function undo
     * @param none
     **************************************************/

    undo: function() {
      console.log("run undo");

      if(this.currNumState){
          --this.currNumState;
      }

      const puttingCanvas = this.arrStateCanvas[this.currNumState];
     // canvas.loadFromJSON(puttingCanvas, canvas.renderAll.bind(canvas));
     let vmu = this;
      canvas.loadFromJSON(puttingCanvas, function(){
        console.log("aga callback ", vmu);
        console.log("dataCanvas : ", canvas.toJSON(['namecard', 'version']));
        //let dataCanvas = JSON.stringify(canvas.toJSON(['namecard', 'version'])).replace('http://cardolini.ru/', '');
        let dataCanvas = JSON.stringify(canvas.toJSON(['namecard', 'version']));
        localStorage[vmu.currentItem.itemN] = JSON.stringify(dataCanvas);
      });


    //   console.log("aga  ");


      canvas.renderAll();

    },


    /*************************************************
     * @function redo
     * @param none
     **************************************************/

    redo: function() {
      console.log("run redo");
      if(this.currNumState < this.stepsUndo){
          ++this.currNumState;
      }
      const puttingCanvas = this.arrStateCanvas[this.currNumState];
      canvas.loadFromJSON(puttingCanvas, canvas.renderAll.bind(canvas));

     let vmr = this;
      canvas.loadFromJSON(puttingCanvas, function(){
        console.log("aga callback ", vmr);
        console.log("dataCanvas : ", canvas.toJSON(['namecard', 'version']));
        //let dataCanvas = JSON.stringify(canvas.toJSON(['namecard', 'version'])).replace('http://cardolini.ru/', '');
        let dataCanvas = JSON.stringify(canvas.toJSON(['namecard', 'version']));
        localStorage[vmr.currentItem.itemN] = JSON.stringify(dataCanvas);
      });
      canvas.renderAll();

    },



    /*************************************************
     * @function saveState
     * @param none
     **************************************************/

    saveState: function() {
      console.log("run saveState");
      let namecard = this.currentItem.itemN;
      let version = '4.0';
      //let dataCanvas = JSON.stringify(canvas.toJSON(['namecard', 'version'])).replace('http://cardolini.ru/', '');
      let dataCanvas = JSON.stringify(canvas.toJSON(['namecard', 'version']));
      const canvJSON = canvas.toJSON(['namecard', 'version']);
      console.log("dataCanvas = ", canvas.toJSON(['namecard', 'version']));

      if(this.arrStateCanvas.length < this.stepsUndo){
        this.arrStateCanvas.splice(this.currNumState, this.stepsUndo-this.currNumState);
          this.arrStateCanvas.push(canvJSON);
          console.log("arrStateCanvas = ", this.arrStateCanvas);
          ++this.currNumState;
      }
      else {
          this.arrStateCanvas.splice(0, 1);
          this.arrStateCanvas.push(canvJSON);
          console.log("arrStateCanvas = ", this.arrStateCanvas);
          this.currNumState = this.stepsUndo;
      }
      localStorage[this.currentItem.itemN] = JSON.stringify(dataCanvas);
    },

    /*************************************************
     * @function upObj
     * @param none
     **************************************************/

    upObj: function() {
      console.log("run upObj");


      canvas.bringForward(canvas.getActiveObject()).renderAll();

      this.saveState();
    },

    /*************************************************
     * @function copyObject
     * @param none
     **************************************************/

    copyObject: function() {
      console.log("run copyObject");


     // canvas.sendBackwards(canvas.getActiveObject()).renderAll();

      let selectedGr = canvas.getActiveObjects();

      for (let obind = 0; obind < selectedGr.length; obind++) {
        const obj = selectedGr[obind];
    console.log("copyObject = ", obj);
      if (!obj) return;

      if (fabric.util.getKlass(obj.type).async) {
        obj.clone(function (clone) {
          console.log("clone = ", clone);
          clone.set({left: 10, top: 10});
          canvas.add(clone);
          //canvas.add(clone).getActiveObject().renderAll();
        });
      }
      else {

        obj.clone(function (clone) {
          console.log("clone = ", clone);
          clone.set({left: 10, top: 10});
          canvas.add(clone);
          //canvas.add(clone).getActiveObject().renderAll();
        });

        //canvas.add(obj.clone().set({left: 10, top: 10}));
        //canvas.add(obj.clone()).getActiveObject();
        //console.log("clone else = ", clone);
        //canvas.add(obj.clone().set({left: 10, top: 10})).getActiveObject().renderAll();
      }
      }




      canvas.renderAll();

      this.saveState();
    },

    /*************************************************
     * @function dnObj
     * @param none
     **************************************************/

    dnObj: function() {
      console.log("run dnObj");


      canvas.sendBackwards(canvas.getActiveObject()).renderAll();

      this.saveState();
    },

    /*************************************************
     * @function flipHorizontal
     * @param none
     **************************************************/

    flipHorizontal: function() {
      console.log("run flipHorizontal");

      let obj = canvas.getActiveObject();
      obj.flipX = !obj.flipX;
      console.log("flipX = ", obj.flipX);

      canvas.renderAll();
      this.saveState();
    },

    /*************************************************
     * @function alignCenterH
     * @param none
     **************************************************/

    alignCenterH: function() {
      console.log("run alignCenterH");

      //let selectedGr = canvas.getSelectionElement();
      let selectedGr = [];
      console.log("selectedGr" , selectedGr);
	    if (!selectedGr) return;
	     selectedGr = canvas.getActiveObjects();
	    let pointC = new fabric.Point(0, 0);
	    let deltaX = 0;
	    let firstObjW = 0;
	    let coordY1 = 0;
	    let coordY2 = 0;
      let i = 0;

      console.log("selectedGr" , selectedGr);

      for (let obind = 0; obind < selectedGr.length; obind++) {
        const alObj = selectedGr[obind];
        //console.log( obind , ' alObj = ' , alObj );
	        alObj.originX='left';
	        alObj.originY='top';
	        //console.log( i + ' Point Left = ' + obj.left );
	        let boundObj = alObj.getBoundingRect();


	        if (obind > 0) {
	            pointC.x = alObj.left;
	            deltaX = boundObj.left - coordY1;
	            console.log(i + '  DELTA= ' + deltaX);

              pointC.x -= deltaX + boundObj.width / 2 - firstObjW / 2;
              pointC.y = alObj.top;
	            //alObj.setTop(pointC.y);

	            alObj.left =pointC.x;

	        } else {
	            coordY1 = boundObj.left;
              firstObjW = boundObj.width;
	        }

      }

	   // canvas.deactivateAllWithDispatch();
	    //selectGrpParam();
	    canvas.renderAll();
      this.saveState();
    },

    /*************************************************
     * @function alignCenterV
     * @param none
     **************************************************/

    alignCenterV: function() {
      console.log("run alignCenterV");

      //let selectedGr = canvas.getSelectionElement();
      let selectedGr = [];
      console.log("selectedGr" , selectedGr);
	    if (!selectedGr) return;
	     selectedGr = canvas.getActiveObjects();
	    let pointC = new fabric.Point(0, 0);
	    let deltaY = 0;
	    let firstObjH = 0;
	    let coordY1 = 0;
	    let coordY2 = 0;
      let i = 0;

      console.log("selectedGr" , selectedGr);

      for (let obind = 0; obind < selectedGr.length; obind++) {
        const alObj = selectedGr[obind];
        //console.log( obind , ' alObj = ' , alObj );
	        alObj.originX='left';
	        alObj.originY='top';
	        //console.log( i + ' Point Left = ' + obj.left );
	        let boundObj = alObj.getBoundingRect();


	        if (obind > 0) {
	            pointC.x = alObj.top;
	            deltaY = boundObj.top - coordY1;
	            console.log(i + '  DELTA= ' + deltaY);
	            pointC.x = alObj.left;
	            pointC.y -= deltaY + boundObj.height / 2 - firstObjH / 2;
	            //alObj.setTop(pointC.y);

	            alObj.top =pointC.y;

	        } else {
	            coordY1 = boundObj.top;
              firstObjH = boundObj.height;
	        }

      }

	   // canvas.deactivateAllWithDispatch();
	    //selectGrpParam();
	    canvas.renderAll();
      this.saveState();
    },



    /*************************************************
     * @function alignLeft
     * @param none
     **************************************************/

    alignLeft: function() {
      console.log("run alignLeft");

      //let selectedGr = canvas.getSelectionElement();
      let selectedGr = [];
      console.log("selectedGr" , selectedGr);
	    if (!selectedGr) return;
	     selectedGr = canvas.getActiveObjects();
	    let pointC = new fabric.Point(0, 0);
	    let deltaX = 0;
	    let firstObjW = 0;
	    let coordY1 = 0;
	    let coordY2 = 0;
      let i = 0;

      console.log("selectedGr" , selectedGr);

      for (let obind = 0; obind < selectedGr.length; obind++) {
        const alObj = selectedGr[obind];
        //console.log( obind , ' alObj = ' , alObj );
	        alObj.originX='left';
	        alObj.originY='top';
	        //console.log( i + ' Point Left = ' + obj.left );
	        let boundObj = alObj.getBoundingRect();


	        if (obind > 0) {
	            pointC.x = alObj.left;
	            deltaX = boundObj.left - coordY1;
	            console.log(i + '  DELTA= ' + deltaX);
	            pointC.x -= deltaX;
	            pointC.y = alObj.top;
	            //alObj.setTop(pointC.y);

	            alObj.left =pointC.x;

	        } else {
	            coordY1 = boundObj.left;

	        }


      }

	   // canvas.deactivateAllWithDispatch();
	    //selectGrpParam();
	    canvas.renderAll();
      this.saveState();
    },

    /*************************************************
     * @function alignRight
     * @param none
     **************************************************/

    alignRight: function() {
      console.log("run alignRight");

      //let selectedGr = canvas.getSelectionElement();
      let selectedGr = [];
      console.log("selectedGr" , selectedGr);
	    if (!selectedGr) return;
	     selectedGr = canvas.getActiveObjects();
	    let pointC = new fabric.Point(0, 0);
	    let deltaX = 0;
	    let firstObjW = 0;
	    let coordY1 = 0;
	    let coordY2 = 0;
      let i = 0;

      console.log("selectedGr" , selectedGr);

      for (let obind = 0; obind < selectedGr.length; obind++) {
        const alObj = selectedGr[obind];
        //console.log( obind , ' alObj = ' , alObj );
	        alObj.originX='left';
	        alObj.originY='top';
	        //console.log( i + ' Point Left = ' + obj.left );
	        let boundObj = alObj.getBoundingRect();


	        if (obind > 0) {
	            pointC.x = alObj.left;
	            deltaX = boundObj.left - coordY1;
	            console.log(i + '  DELTA= ' + deltaX);
	            pointC.x -= deltaX + boundObj.width - firstObjW;
	            pointC.y = alObj.top;
	            //alObj.setTop(pointC.y);

	            alObj.left =pointC.x;

	        } else {
	            coordY1 = boundObj.left;
	            firstObjW = boundObj.width;

	        }


      }

	   // canvas.deactivateAllWithDispatch();
	    //selectGrpParam();
	    canvas.renderAll();
      this.saveState();
    },



    /*************************************************
     * @function alignTop
     * @param none
     **************************************************/

    alignTop: function() {
      console.log("run alignTop");

      //let selectedGr = canvas.getSelectionElement();
      let selectedGr = [];
      console.log("selectedGr" , selectedGr);
	    if (!selectedGr) return;
	     selectedGr = canvas.getActiveObjects();
	    let pointC = new fabric.Point(0, 0);
	    let deltaY = 0;
	    let firstObjH = 0;
	    let coordY1 = 0;
	    let coordY2 = 0;
      let i = 0;

      console.log("selectedGr" , selectedGr);

      for (let obind = 0; obind < selectedGr.length; obind++) {
        const alObj = selectedGr[obind];
        //console.log( obind , ' alObj = ' , alObj );
	        alObj.originX='left';
	        alObj.originY='top';
	        //console.log( i + ' Point Left = ' + obj.left );
	        let boundObj = alObj.getBoundingRect();


	        if (obind > 0) {
	            pointC.y = alObj.top;
	            deltaY = boundObj.top - coordY1;
	            console.log(i + '  DELTA= ' + deltaY);
	            pointC.x = alObj.left;
	            pointC.y -= deltaY;
	            //alObj.setTop(pointC.y);

	            alObj.top =pointC.y;

	        } else {
	            coordY1 = boundObj.top;
	            firstObjH = boundObj.height;

	        }


      }

	   // canvas.deactivateAllWithDispatch();
	    //selectGrpParam();
	    canvas.renderAll();
      this.saveState();
    },

    /*************************************************
     * @function alignBottom
     * @param none
     **************************************************/

    alignBottom: function() {
      console.log("run alignBottom");

      //let selectedGr = canvas.getSelectionElement();
      let selectedGr = [];
      console.log("selectedGr" , selectedGr);
	    if (!selectedGr) return;
	     selectedGr = canvas.getActiveObjects();
	    let pointC = new fabric.Point(0, 0);
	    let deltaY = 0;
	    let firstObjH = 0;
	    let coordY1 = 0;
	    let coordY2 = 0;
      let i = 0;

      console.log("selectedGr" , selectedGr);

      for (let obind = 0; obind < selectedGr.length; obind++) {
        const alObj = selectedGr[obind];
        //console.log( obind , ' alObj = ' , alObj );
	        alObj.originX='left';
	        alObj.originY='top';
	        //console.log( i + ' Point Left = ' + obj.left );
	        let boundObj = alObj.getBoundingRect();


	        if (obind > 0) {
	            pointC.y = alObj.top;
	            deltaY = boundObj.top - coordY1;
	            console.log(i + '  DELTA= ' + deltaY);
	            pointC.x = alObj.left
	            pointC.y -= deltaY + boundObj.height - firstObjH;
	            //alObj.setTop(pointC.y);

	            alObj.top =pointC.y;

	        } else {
	            coordY1 = boundObj.top;
	            firstObjH = boundObj.height;

	        }


      }

	   // canvas.deactivateAllWithDispatch();
	    //selectGrpParam();
	    canvas.renderAll();
      this.saveState();
    },



    /*************************************************
     * @function flipVertical
     * @param none
     **************************************************/

    flipVertical: function() {
      console.log("run flipVertical");

      let obj = canvas.getActiveObject();
      obj.flipY = !obj.flipY;
      console.log("flipX = ", obj.flipY);
      canvas.renderAll();
      this.saveState();
    },


    /*************************************************
     * @function showCropRect
     * @param wd
     * NOTE  wd - толщина обрезной рамки
     **************************************************/

    showCropRect: function(wd) {
      console.log("run showCropRect");



	        ctx[this.currentPage].beginPath();
	        ctx[this.currentPage].lineWidth = wd;
	        ctx[this.currentPage].strokeStyle = 'rgba(255,0,0,0.4)';
	        ctx[this.currentPage].rect(0, 0, canvas.getWidth(), canvas.getHeight());
	        ctx[this.currentPage].stroke();

    },

    /*************************************************
     * @function setupCanvas
     * @param none
     **************************************************/

    setupCanvas: function() {
      console.log("run setup Canvas", canvas);

      console.log("Новый скрипт V3.0");
      fabric.Object.prototype.borderColor = "rgba(0,0,180,1)";  // NOTE  Color border controlling helpers
      fabric.Object.prototype.borderScaleFactor = 1;            // NOTE Border scale controlling helpers  (0-1)
      fabric.Object.prototype.cornerColor = "rgba(40,10,150,1)";// NOTE Color corners controlling helpers
      fabric.Object.prototype.cornerSize = 14;                  // NOTE Corners size controlling helpers
      fabric.Object.prototype.hasBorders = true;                // NOTE Render border controlling helpers
      fabric.Object.prototype.hasControls = true;               // NOTE Render all controlling helpers
      fabric.Object.prototype.hasRotatingPoint = true;          // NOTE Render rotating point controlling helpers
      fabric.Object.prototype.padding = 0;                      // NOTE Padding between object and its controlling borders (in pixels) controlling helpers
      fabric.Object.prototype.rotatingPointOffset = 30;         // NOTE Padding between object and its controlling borders (in pixels) controlling helpers
      fabric.Object.prototype.transparentCorners = false;       // NOTE Off transparent corners controlling helpers
      fabric.Object.prototype.transparentCorners = false;       // NOTE Off transparent corners controlling helpers


/*       canvas.on('selection:created', function(e) {

        this.selectObj(e);

      }.bind(this)); */
      canvas.setBackgroundColor("#fff", canvas.renderAll.bind(canvas));



	    initCenteringGuidelines(canvas);
	    initAligningGuidelines(canvas);

      canvas.on({
              'selection:updated': function(e) {
                this.selectObj(e);
              }.bind(this),
              'selection:cleared': function(e) {
                this.deselectObj(e);
              }.bind(this),
              'selection:created': function(e) {
                this.selectObj(e);
              }.bind(this),
              'object:modified': function(e) {
                console.log('Object Modified');
                this.saveState();
              }.bind(this)
            });
      // ================ Event rotating object and discret to 5 degree ====================== //
      canvas.on("object:rotating", function(rotEvtData) {
          let targetObj = rotEvtData.target;
          let snapAngle = roundTo(targetObj.angle, 5);
          targetObj.rotate(snapAngle).setCoords();
          canvas.renderAll();

      });




     // this.showCropRect(20);
      //let dataCanvas = JSON.stringify(canvas.toJSON(['namecard', 'version'])).replace('http://cardolini.ru/', '');
      let dataCanvas = JSON.stringify(canvas.toJSON(['namecard', 'version']));

                    if(localStorage[this.currentItem.itemN]){
                     // console.log("load from localStorage data = ", JSON.parse(localStorage.getItem(this.currentItem.itemN)));
                      canvas.loadFromJSON(JSON.parse(localStorage.getItem(this.currentItem.itemN)), canvas.renderAll.bind(canvas));

                    }
                    else{

                        localStorage[this.currentItem.itemN] = JSON.stringify(dataCanvas);
                        this.addTextStart();
                        this.setFontStart('Lobster');
                        this.setFontStart('Marck Script');
                        this.setFontStart('Roboto');
                        canvas.renderAll();

                    }


      canvas.renderAll();
    },

    /*************************************************
     * @function setFontStart
     * @param nameF-
     **************************************************/

    setFontStart: function(nameF) {
      console.log("run setFontStart");
      	  canvas.getActiveObject().fontFamily = nameF;
          canvas.renderAll();
         // this.saveState();

    },

    /*************************************************
     * @function addRect
     * @param top
     * @param left -
     * @param width -
     * @param height -
     **************************************************/

    addRect: function(dataRect) {
      console.log("run addRect");
      let rect = new fabric.Rect({
        top: dataRect.top,
        left: dataRect.left,
        width: dataRect.width,
        height: dataRect.height,
        fill: "#AAAAAAFF"
      });




      canvas.add(rect).setActiveObject(rect);
      canvas.renderAll();
      this.saveState();
    },

    /*************************************************
     * @function addCircle
     * @param top
     * @param left -
     * @param width -
     * @param height -
     **************************************************/

    addCircle: function(dataCircle) {
      console.log("run addCircle");
	    let newCirc = new fabric.Circle({
	        top: dataCircle.top,
	        left: dataCircle.left,
	        radius: dataCircle.r1,
	        fill: "#AAAAAA"
	    });
      canvas.add(newCirc).setActiveObject(newCirc);
      canvas.renderAll();
      this.saveState();
    },

    /*************************************************
     * @function addText
     * @param none
     **************************************************/

    addText: function() {
      console.log("run addText");
	    var newITextadd = new fabric.Textbox('Текст можно редактировать \nдвойным кликом \nTEST testing text', { fontFamily: 'Roboto', left: 10, top: 10, fontSize: 24, fontStyle: "normal", fontWeight: "normal", lineHeight: "1", useNative: true });
	    canvas.add(newITextadd).setActiveObject(newITextadd);

	    canvas.renderAll();
	    this.saveState();
    },

    /*************************************************
     * @function addTextStart
     * @param none
     **************************************************/
    addTextStart: function() {
      var newTextadd = new fabric.Textbox(
        "Текст можно редактировать \nдвойным кликом \nTEST testing text",
        {
          fontFamily: "Roboto",
          fill: "#000000",
          left: 10,
          top: 10,
          width: 220,
          fontSize: 24,
          fontStyle: "normal",
          fontWeight: "normal",
          lineHeight: "0.8",
          originX: 'left',
          originY: 'top'
        }
      );

      canvas.add(newTextadd).setActiveObject(newTextadd);
      this.setFontStart('Roboto');
      canvas.renderAll.bind(canvas);
      this.saveState();

    },

    /*************************************************
     * @function textAlign
     * @param objSel
     **************************************************/
    textAlign: function(objSel) {
      console.log("textAlign objSel = ", objSel);

    },

    /*************************************************
     * @function selectObj
     * @param objSel
     **************************************************/
    selectObj: function(objSel) {
      console.log("selectObj objSel = ", objSel);
      let selectedGr = [];
      selectedGr = canvas.getActiveObjects();
      console.log("selectObj selectedGr = ", selectedGr);

for (let sind = 0; sind < selectedGr.length; sind++) {
  const elSelection = selectedGr[sind];



  if(elSelection.isType('group')){
      console.log("selectObj group ",elSelection);
      this.isSelectObj = false;

  }

  if(elSelection.isType('xyz')){
      console.log("selectObj xyz ",elSelection);

  }
  if(elSelection.isType('activeSelection')){
      console.log("selectObj activeSelection ",elSelection);

  }

  if(elSelection.isType('textbox')){
        this.isSelectObj = false;
        console.log("selectObj textbox ",elSelection);
        console.log("color textbox = ", elSelection.fill);
        console.log("fontStyle textbox = ", elSelection.fontStyle);
        console.log("fontWeight textbox = ", elSelection.fontWeight);
        console.log("textAlign textbox = ", elSelection.textAlign);
        this.toolText = true;
        this.colors = elSelection.fill;

        switch (elSelection.textAlign) {
          case 'left':
            this.toggle_exclusive = 1;
            break;
          case 'center':
            this.toggle_exclusive = 2;
            break;
          case 'right':
            this.toggle_exclusive = 3;
            break;
          case 'justify-left':
            this.toggle_exclusive = 4;
            break;

          default:
            break;
        }

        switch (elSelection.fontStyle) {
          case 'normal':

              console.log("!ITALIC : ",this.toggle_multiple.indexOf(1))
              if(this.toggle_multiple.indexOf(1) !== -1){
                this.toggle_multiple = [1];
              }
              else {
                this.toggle_multiple = [];
              }


            break;
          case 'italic':
            console.log("!ITALIC : ",this.toggle_multiple.indexOf(1))
              if(this.toggle_multiple.indexOf(1) !== -1){
                this.toggle_multiple = [1,2];
              }
              else {
                this.toggle_multiple = [2];
              }

            break;
          case 'oblique':
          //  this.toggle_multiple = 3;
            break;

          default:
            break;
        }

        switch (elSelection.fontWeight) {
          case 'normal':
console.log("!BOLD : ",this.toggle_multiple.indexOf(2))
              if(this.toggle_multiple.indexOf(2) !== -1){
                this.toggle_multiple = [2];
              }
              else {
                this.toggle_multiple = [];
              }

            break;
          case 'bold':
console.log("!BOLD : ",this.toggle_multiple.indexOf(2))
              if(this.toggle_multiple.indexOf(2) !== -1){
                this.toggle_multiple = [1,2];
              }
              else {
                this.toggle_multiple = [1];
              }
            break;
          default:
            break;
        }
       // this.selectColors = tinycolor(elSelection.fill).toHex();
  }

  if(elSelection.isType('image')){
        this.isSelectObj = false;
        console.log("selectObj image ");
        console.log("color image = ", elSelection.fill);
  }

  if(elSelection.isType('rect')){
        this.isSelectObj = false;
        console.log("selectObj rect");
        console.log("color rect = ", elSelection.fill);
        this.colors = elSelection.fill;
        this.toolText = false;
  }
  if(elSelection.isType('circle')){
        this.isSelectObj = false;
        console.log("selectObj circle");
        console.log("color circle = ", elSelection.fill);
        this.colors = elSelection.fill;
        this.toolText = false;
  }
  if(elSelection.isType('path')){
        this.isSelectObj = false;
        console.log("selectObj path");
        console.log("color path = ", elSelection.fill);
        this.colors = elSelection.fill;
        this.toolText = false;
  }

}

      canvas.renderAll();
     // this.saveState();
    },

    /*************************************************
     * @function deselectObj
     * @param none
     **************************************************/
    deselectObj: function(et) {
      console.log("deselectObj objSel ");

      this.toolText = false;
      this.isSelectObj = true;


      canvas.renderAll();
      //this.saveState();
    },

    /*************************************************
     * @function setColor
     * @param fillColor
     **************************************************/
    setColor: function(fillColor) {
      console.log("selectObj fillColor = ", fillColor);
      let selectedGr = [];
      selectedGr = canvas.getActiveObjects();
      console.log("selectObj selectedGr = ", selectedGr);




      for (let sind = 0; sind < selectedGr.length; sind++) {
        const elSelection = selectedGr[sind];

      if(elSelection.isType('group')){
      console.log("selectObj ->  GROUP ");

      elSelection.forEachObject(function(obj){
        if(obj.fill === '#FFF' || obj.fill === '#FFFFFF' || obj.fill === '#ffffff' || obj.fill === '#fff'){
        console.log("GET WHITE COLOR infoObject in GROUP=",obj.fill);
        }
        else {
              if(typeof this.colors.hex8 == 'undefined') {
                    //elSelection.setColor(this.colors.hex8);
              }
              else {
                  obj.setColor(this.colors.hex8);
              }
        }

      }.bind(this));



      }
      else{

        console.log("selectObj fillColor = ", this.colors.hex8);
        if(typeof this.colors.hex8 == 'undefined') {
              //elSelection.setColor(this.colors.hex8);
        }
        else {
            elSelection.setColor(this.colors.hex8);
        }

      //elSelection.fill = '#f00' ;
      canvas.renderAll.bind(canvas);
      //elSelection.fill = 'rgba('+this.colors.r+','+this.colors.g+','+this.colors.b+','+this.colors.a+')' ;
      /*   if(elSelection.isType('textbox')){
              console.log("selectObj elSelection = ", elSelection.fill);
              this.colors = tinycolor(elSelection.fill).toRgb();
        } */

      }
      }
      canvas.renderAll();
      //selectObjParam();
      this.saveState();
    },



  }
};
</script>

<style>
.canvas-container {
  margin: auto;
  /*border: 15px rgba(255, 0, 0, 0.5) solid;
   border-style: inset; */
}

.borderCanvasPrint{
  border: 15px rgba(255, 0, 0, 0.5) solid;
}

.borderCanvasWEB{
  border: 1px rgba(130, 130, 130, 0.5) solid;
}

.image-lib{

  float: left;
}

.active-filtr-img{

background-color: #d6b5ef !important;

}
.swiper-container{
padding: 30px 35px;
}

.swiper-slide{
height: 160px;
width: 160px;

}

.swiper-pagination{
  bottom: 20px;
}
.container-canvas{
  display: block;
  overflow: auto;
}

div.v-uploader .uploader-button[data-v-18963f2e]{

  border: none;
  background: transparent !important;
  box-shadow: none !important;
}
.container{
  padding: 12px;
}

.theme--light.v-btn.tgglbtn.v-btn.v-btn--active{
color: #b39ddb ;
}
.theme--light.v-btn.tgglbtn{
width: 24px;
height: 24px;
  color: #fff;
}
</style>
